import styled from 'styled-components';

import Btn from 'components/Button';
import PreviewDef from 'components/GoogleCloudFilePreview';

export const Container = styled.div`
  position: relative;
  width: 100%;
  margin: 10px 0;
`;

export const HeadWrap = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const MenuBtn = styled(Btn)`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-left: 8px;
`;

export const ButtonWrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
`;

export const Button = styled(Btn)`
  height: 25px;
  width: auto;
  padding: 0 8px;
`;

export const Preview = styled(PreviewDef)`
  height: 120px;
  border: 1px solid var(--color-grey97);
  background-color: var(--color-white);
  margin: 10px 0 5px 0;
  &:disabled {
    border: 1px solid var(--color-grey97);
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
